import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';

import { designsStateCreator } from './state';

export { designsStoreSelector } from './selector';

export const useDesignsStore = create(
  subscribeWithSelector(designsStateCreator)
);
